export default __webpack_public_path__ + "static/media/slider_photo_(3)[1].d0307d25.png";